import { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';
import { Text } from 'react-aria-components';
import FooterLogo from 'src/assets/icons/footer-logo.svg';
import SkipToMainContent, {
  MAIN_CONTENT_ID,
} from 'src/components/layout/SkipToMainContent';

const RootLayout = ({
  className,
  children,
}: {
  className?: string;
  children: ReactNode;
}) => {
  return (
    <>
      <SkipToMainContent />
      <main
        id={MAIN_CONTENT_ID}
        className="flex items-center h-screen justify-center px-2 sm:px-10"
      >
        <div className={twMerge('max-w-[900px] w-full', className)}>
          {children}
          <footer className="flex items-center justify-between font-normal text-xs text-center text-surface-alt-75 py-9 px-10">
            <Text elementType="p">
              © {new Date().getFullYear()} LAD Custom Publishing
            </Text>
            <div className="flex items-center justify-center gap-2">
              <Text elementType="span">Powered by</Text>
              <FooterLogo
                aria-hidden="true"
                className="flex-shrink-0 w-24 h-8"
              />
            </div>
          </footer>
        </div>
      </main>
    </>
  );
};

export default RootLayout;
